import { render, staticRenderFns } from "./lstMenu.vue?vue&type=template&id=66966163&"
import script from "./lstMenu.vue?vue&type=script&lang=js&"
export * from "./lstMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports